<div [ngClass]="{ 'container-fluid': !containerMode, 'px-4': !containerMode }" class="container-fluid px-4">
  <div class="container-shadow" [ngClass]="{ container: containerMode, 'container-fluid': !containerMode }">
    <h2 class="pt-5 pb-1">
      <span class="float-right">
        <small>
          <button type="button" class="btn btn-sm btn-outline-secondary" title="Refresh" [disabled]="loading" (click)="loadOutgoingJob()">
            <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': loading }"></i>
          </button>
        </small>
      </span>
      Outgoing Job -&nbsp;
      <small>
        <i class="text-secondary">#{{ outgoingJobId }}</i>
        <span *ngIf="!loading && outgoingJob">
          &nbsp;&nbsp;
          <small>
            {{ outgoingJob.created_at_str }}
            &nbsp;
            <app-outgoing-job-status [outgoingJob]="outgoingJob"></app-outgoing-job-status>
            <span *ngIf="outgoingJob.priority">
              &nbsp;
              <app-badge badgeType="danger">Priority</app-badge>
            </span>
          </small>
        </span>
      </small>
      <br *ngIf="!loading && outgoingJob" />
      <small *ngIf="!loading && outgoingJob">
        <small>
          <b>Matter:&nbsp;</b>
          <span *ngIf="outgoingJob.matter_id && outgoingJob.matter_number">
            <a class="font-weight-normal" [routerLink]="'/matters/' + outgoingJob.matter_id">{{ outgoingJob.matter_number }}</a>
            &nbsp;-&nbsp;{{ outgoingJob.matter_name }}
          </span>
          <span class="text-warning" *ngIf="!outgoingJob.matter_id || !outgoingJob.matter_number"> Matter {{ !outgoingJob.matter_id ? 'not specified' : 'not found' }} </span>
          <span *ngIf="outgoingJob.auto_outgoing_rule_present">
            <br />
            <b>Created by&nbsp;</b>
            <a class="font-weight-normal" target="_blank" [routerLink]="'/auto_outgoing_rules/' + outgoingJob.auto_outgoing_rule_id">Auto Outgoing Rule #{{ outgoingJob.auto_outgoing_rule_id }}</a>
          </span>
          <br />
          <span *ngIf="outgoingJob.outgoing_documents.length > 0">
            <app-pagination-count
              [count]="outgoingJob.outgoing_documents.length"
              singularName="document"
              pluralName="documents"
            ></app-pagination-count>
            &nbsp;
          </span>
          <span *ngIf="outgoingJob.outgoing_envelopes.length > 0">
            <app-pagination-count
              [count]="outgoingJob.outgoing_envelopes.length"
              singularName="envelope"
              pluralName="envelopes"
            ></app-pagination-count>
            &nbsp;
          </span>
          <span *ngIf="outgoingJob.outgoing_checks.length > 0">
            <app-pagination-count
              [count]="outgoingJob.outgoing_checks.length"
              singularName="check"
              pluralName="checks"
            ></app-pagination-count>
            &nbsp;
          </span>
          <span *ngIf="outgoingJob.outgoing_labels.length > 0">
            <app-pagination-count
              [count]="outgoingJob.outgoing_labels.length"
              singularName="label"
              pluralName="labels"
            ></app-pagination-count>
            &nbsp;
          </span>
          <span *ngIf="outgoingJob.outgoing_document_faxes.length > 0">
            <app-pagination-count
              [count]="outgoingJob.outgoing_document_faxes.length"
              singularName="fax"
              pluralName="faxes"
            ></app-pagination-count>
            &nbsp;
          </span>
        </small>
      </small>
    </h2>
    <div *ngIf="!loading && outgoingJob && outgoingJob.last_errors_array && outgoingJob.last_errors_array.length > 0" class="card border-danger">
      <h4 class="card-header bg-danger text-white">Errors</h4>
      <div class="card-body">
        <div *ngFor="let error of outgoingJob.last_errors_array">
          <b>{{ error.error_model }}:</b><br />
          <span [innerHTML]="error.error_message"></span>
        </div>
      </div>
    </div>
    <div class="btn-group btn-group-sm mt-2" *ngIf="!loading && outgoingJob">
      <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="cancellingOutgoingJob || processingAction" (click)="cancelOutgoingJob()">
        <i class="fas fa-ban"></i>
        &nbsp;
        {{ cancellingOutgoingJob ? 'Cancelling' : 'Cancel' }}
        <span *ngIf="cancellingOutgoingJob">
          &nbsp;
          <i class="fas fa-spinner fa-fw fa-pulse"></i>
        </span>
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="restartingOutgoingJob || processingAction" (click)="restartOutgoingJob()">
        <i class="fas fa-undo fa-fw spin-reverse" [ngClass]="{ 'fa-spin': restartingOutgoingJob }"></i>&nbsp;{{ restartingOutgoingJob ? 'Restarting' : 'Restart' }}
      </button>
      <button type="button" class="btn btn-sm btn-primary" [disabled]="printingOutgoingJob || processingAction" (click)="printOutgoingJob()">
        <i class="fas fa-print" [ngClass]="{ 'fa-spin': printingOutgoingJob }"></i>&nbsp;
        {{ printingOutgoingJob ? 'Printing' : 'Print' }}
      </button>
    </div>
    <span *ngIf="!loading && outgoingJob">&nbsp;</span>
    <div class="btn-group btn-group-sm mt-2" *ngIf="!loading && outgoingJob">
      <button *ngIf="lockFileExists" type="button" class="btn btn-sm btn-warning" [disabled]="deletingLockFile || processingAction" (click)="deleteLockFile()">
        <i class="fas fa-unlock"></i>&nbsp;{{ deletingLockFile ? 'Deleting' : 'Delete' }} Lock File
        <span *ngIf="deletingLockFile">
          &nbsp;
          <i class="fas fa-spinner fa-fw fa-pulse"></i>
        </span>
      </button>
    </div>
    <span *ngIf="!loading && outgoingJob">&nbsp;</span>
    <div class="btn-group btn-group-sm mt-2" *ngIf="!loading && outgoingJob">
      <button type="button" *ngIf="outgoingJob.status == 'error' || outgoingJob.status == 'stalled'" [disabled]="continuingOutgoingJob || processingAction" (click)="continueOutgoingJob()" class="btn btn-sm btn-success">
        <i class="fas fa-redo" [ngClass]="{ 'fa-spin': continuingOutgoingJob }"></i>&nbsp;{{ continuingOutgoingJob ? 'Continuing' : 'Continue' }}
      </button>
      <button type="button" *ngIf="(canProcessAllOutgoingJobs || currentUserId == outgoingJob.checked_out_by) && outgoingJob.status == 'ready' && outgoingJob.checked_out" [disabled]="finishingOutgoingJob || processingAction" (click)="finishOutgoingJob()" class="btn btn-sm btn-success">
        <i class="fas fa-print"></i>&nbsp;{{ finishingOutgoingJob ? 'Completing' : 'Finish' }}
        <span *ngIf="finishingOutgoingJob">
          &nbsp;
          <i class="fas fa-spinner fa-fw fa-pulse"></i>
        </span>
      </button>
      <button
        type="button"
        *ngIf="(canProcessAllOutgoingJobs || currentUserId == outgoingJob.checked_out_by) && outgoingJob.status == 'ready' && outgoingJob.checked_out"
        [disabled]="releasingOutgoingJob || processingAction"
        (click)="releaseOutgoingJob()"
        class="btn btn-sm btn-primary"
        title="Release outgoing job"
      >
        <i class="fas fa-user-slash"></i>&nbsp;{{ releasingOutgoingJob ? 'Releasing' : 'Release' }}
        <span *ngIf="releasingOutgoingJob">
          &nbsp;
          <i class="fas fa-spinner fa-fw fa-pulse"></i>
        </span>
      </button>
      <button type="button" *ngIf="outgoingJob.status == 'ready' && !outgoingJob.checked_out" [disabled]="takingOutgoingJob || processingAction" (click)="takeOutgoingJob()" class="btn btn-sm btn-primary" title="Take outgoing job">
        <i class="fas fa-user-check"></i>&nbsp;{{ takingOutgoingJob ? 'Assigning' : 'Take' }}
        <span *ngIf="takingOutgoingJob">
          &nbsp;
          <i class="fas fa-spinner fa-fw fa-pulse"></i>
        </span>
      </button>
    </div>
    <span *ngIf="!loading && outgoingJob && outgoingJob.checked_out"
      >&nbsp;&nbsp;
      <b>Checked out by:&nbsp;</b>
      <a [routerLink]="'/contacts/' + outgoingJob.checked_out_by_contact_id">{{ outgoingJob.checked_out_by_user_name }}</a>
    </span>
    <hr />
    <div class="card mb-4" *ngIf="!loading && outgoingJob && outgoingJob.outgoing_documents && outgoingJob.outgoing_documents.length > 0">
      <h4 class="card-header">Documents</h4>
      <div cass="card-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>File</th>
              <th>Pages</th>
              <th>Copies</th>
              <th>Method</th>
              <th>Destination</th>
              <th>Result</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let outgoingDocument of outgoingJob.outgoing_documents">
              <td>{{ outgoingDocument.id }}</td>
              <td>
                <a [href]="outgoingDocument.document_url" *ngIf="outgoingDocument.document_readable">
                  <i class="fas fa-file-pdf text-danger"></i>&nbsp;
                  {{ outgoingDocument.document_name }}
                </a>
                <span class="text-danger" *ngIf="!outgoingDocument.document_readable">
                  <span *ngIf="outgoingDocument.document_file_exists"> Document {{ outgoingDocument.document_name }} exists but inaccessible. </span>
                  <span *ngIf="!outgoingDocument.document_file_exists && outgoingDocument.document_exists">
                    Document {{ outgoingDocument.document_name }} file no longer exists. &nbsp;
                    <a href="#" *ngIf="outgoingDocument.document_downloadable" (click)="$event.preventDefault(); writeToPdf(outgoingDocument)" title="Attempt to write to PDF">
                      <i class="fas fa-redo" [ngClass]="{ 'fa-spin': outgoingDocument.writingToPdf }"></i>
                    </a>
                  </span>
                  <span *ngIf="!outgoingDocument.document_exists"> Document record is missing. </span>
                </span>
              </td>
              <td>{{ outgoingDocument.pages || 'All' }}</td>
              <td>{{ outgoingDocument.copies || 1 }}</td>
              <td>{{ outgoingDocument.way_str }}</td>
              <td>
                <a *ngIf="outgoingDocument.way == 'share'" [href]="'mailto:' + outgoingDocument.destination">
                  {{ outgoingDocument.destination }}
                </a>
                <span *ngIf="outgoingDocument.way != 'share'">{{ outgoingDocument.destination_str }}</span>
              </td>
              <td>{{ outgoingDocument.result_str }}</td>
              <td>
                <span *ngIf="outgoingDocument.way != 'fax' && outgoingDocument.way != 'share'">
                  <app-outgoing-item-status [sent]="outgoingDocument.sent_at" [sentInfo]="outgoingDocument.sent_at_str"></app-outgoing-item-status>
                  &nbsp;
                  <a href="#" (click)="$event.preventDefault(); outgoingDocument.sent_at ? restartOutgoingDocument(outgoingDocument) : printOutgoingDocument(outgoingDocument)">
                    <i class="fas" [ngClass]="{ 'fa-undo': outgoingDocument.sent_at, 'fa-print': !outgoingDocument.sent_at, 'spin-reverse': outgoingDocument.sent_at, 'fa-spin': outgoingDocument.printing || outgoingDocument.restarting }"></i>
                    {{ outgoingDocument.sent_at ? (outgoingDocument.restarting ? 'Restarting' : 'Restart') : outgoingDocument.printing ? 'Printing' : 'Print' }}
                  </a>
                </span>
                <span *ngIf="outgoingDocument.way == 'share'">
                  <app-outgoing-item-status [sent]="outgoingDocument.sent_at" [sentInfo]="outgoingDocument.sent_at_str"></app-outgoing-item-status>
                  <span *ngIf="outgoingDocument.latest_resend_at_str">
                    &nbsp;|&nbsp;Resent {{ outgoingDocument.latest_resend_at_str }}
                    <span *ngIf="outgoingDocument.resend_count > 1">({{ outgoingDocument.resend_count }} times)</span>
                  </span>
                  &nbsp;
                  <a href="#" (click)="$event.preventDefault(); resendOutgoingDocument(outgoingDocument)">
                    <i class="fas fa-paper-plane" [ngClass]="{ 'fa-spin': outgoingDocument.resending }"></i>
                    {{ outgoingDocument.resending ? (outgoingDocument.sent_at ? 'Resending' : 'Sending') : outgoingDocument.sent_at ? 'Resend' : 'Send' }}
                  </a>
                </span>
                <span *ngIf="outgoingDocument.way == 'fax'">
                  <app-outgoing-item-status
                    [sent]="outgoingDocument.outgoing_document_fax_successful"
                    [sentInfo]="outgoingDocument.outgoing_document_fax_created_at_str"
                    *ngIf="outgoingDocument.outgoing_document_faxes_present"
                  ></app-outgoing-item-status>
                  <span *ngIf="!outgoingDocument.outgoing_document_faxes_present">This fax is still being created and sent to Phaxio. There is nothing to report as of now.</span>
                  &nbsp;
                  <a href="#" *ngIf="!(outgoingDocument.outgoing_document_fax_successful && outgoingDocument.result == 'sending')" (click)="$event.preventDefault(); sendOutgoingDocumentFax(outgoingDocument)">
                    <i class="fas" [ngClass]="{ 'fa-fax': !outgoingDocument.outgoing_document_fax_successful, 'fa-redo': outgoingDocument.outgoing_document_fax_successful, 'fa-spin': outgoingDocument.sending_fax }"></i>
                    &nbsp;
                    {{ outgoingDocument.outgoing_document_faxes_present ? (outgoingDocument.outgoing_document_fax_successful ? (outgoingDocument.sending_fax ? 'Resending' : 'Resend') : outgoingDocument.sending_fax ? 'Sending' : 'Send') : outgoingDocument.sending_fax ? 'Sending' : 'Try Send' }}
                  </a>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card mb-4" *ngIf="!loading && outgoingJob && outgoingJob.outgoing_envelopes && outgoingJob.outgoing_envelopes.length > 0">
      <h4 class="card-header">Envelopes</h4>
      <div cass="card-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Contact</th>
              <th>Address</th>
              <th>Copies</th>
              <th>Destination</th>
              <th>Result</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let outgoingEnvelope of outgoingJob.outgoing_envelopes">
              <td>{{ outgoingEnvelope.id }}</td>
              <td>
                <a *ngIf="outgoingEnvelope.contact_id" [routerLink]="'/contacts/' + outgoingEnvelope.contact_id">
                  {{ outgoingEnvelope.contact_name }}
                </a>
              </td>
              <td [innerHTML]="outgoingEnvelope.full_address | safeHtml"></td>
              <td>{{ outgoingEnvelope.copies }}</td>
              <td>{{ outgoingEnvelope.destination_str }}</td>
              <td>{{ outgoingEnvelope.result_str }}</td>
              <td>
                <app-outgoing-item-status [sent]="outgoingEnvelope.sent" [sentInfo]="outgoingEnvelope.sent_at_str"></app-outgoing-item-status>
                &nbsp;
                <a href="#" (click)="$event.preventDefault(); outgoingEnvelope.sent ? restartOutgoingEnvelope(outgoingEnvelope) : finishOutgoingEnvelope(outgoingEnvelope)">
                  <i class="fas" [ngClass]="{ 'fa-undo': outgoingEnvelope.sent, 'fa-envelope': !outgoingEnvelope.sent, 'spin-reverse': outgoingEnvelope.sent, 'fa-spin': outgoingEnvelope.restarting || outgoingEnvelope.sending }"></i>
                  &nbsp;
                  {{ outgoingEnvelope.sent ? (outgoingEnvelope.restarting ? 'Restarting' : 'Restart') : outgoingEnvelope.sending ? 'Processing' : 'Finish' }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card mb-4" *ngIf="!loading && outgoingJob && outgoingJob.outgoing_labels && outgoingJob.outgoing_labels.length > 0">
      <h4 class="card-header">Labels</h4>
      <div cass="card-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Matter</th>
              <th>Destination</th>
              <th>Result</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let outgoingLabel of outgoingJob.outgoing_labels">
              <td>{{ outgoingLabel.id }}</td>
              <td>
                <a [routerLink]="'/matters/' + outgoingLabel.matter_id">{{ outgoingLabel.matter_number }}</a>
              </td>
              <td>
                <a [href]="'/outgoing_jobs/' + outgoingJob.id + '/outgoing_labels/' + outgoingLabel.id + '.pdf'">{{ outgoingLabel.destination_str }}</a>
              </td>
              <td>{{ outgoingLabel.result_str }}</td>
              <td>
                <app-outgoing-item-status [sent]="outgoingLabel.sent" [sentInfo]="outgoingLabel.sent_at_str"></app-outgoing-item-status>
                &nbsp;
                <a href="#" (click)="$event.preventDefault(); outgoingLabel.sent ? restartOutgoingLabel(outgoingLabel) : finishOutgoingLabel(outgoingLabel)">
                  <i class="fas" [ngClass]="{ 'fa-undo': outgoingLabel.sent, 'fa-envelope': !outgoingLabel.sent, 'spin-reverse': outgoingLabel.sent, 'fa-spin': outgoingLabel.restarting || outgoingLabel.sending }"></i>
                  &nbsp;
                  {{ outgoingLabel.sent ? (outgoingLabel.restarting ? 'Restarting' : 'Restart') : outgoingLabel.sending ? 'Processing' : 'Finish' }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card mb-4" *ngIf="!loading && outgoingJob && outgoingJob.outgoing_checks && outgoingJob.outgoing_checks.length > 0">
      <h4 class="card-header">Checks</h4>
      <div cass="card-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Check #</th>
              <th>Payee</th>
              <th>Amount</th>
              <th>Destination</th>
              <th>Result</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let outgoingCheck of outgoingJob.outgoing_checks">
              <td>{{ outgoingCheck.id }}</td>
              <td>
                <a [href]="'/outgoing_jobs/' + outgoingCheck.outgoing_job_id + '/outgoing_checks/' + outgoingCheck.id">{{ outgoingCheck.check_number }}</a>
              </td>
              <td [attr.colspan]="outgoingCheck.reserved_check_present ? '2' : '1'">
                <span *ngIf="outgoingCheck.reserved_check_present"> This is a reserved check given to {{ outgoingCheck.reserved_check_user_name }} </span>
                <a *ngIf="!outgoingCheck.reserved_check_present" [routerLink]="'/contacts/' + outgoingCheck.payee_id">{{ outgoingCheck.payee_name }}</a>
              </td>
              <td *ngIf="!outgoingCheck.reserved_check_present">{{ outgoingCheck.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
              <td>{{ outgoingCheck.destination_str }}</td>
              <td>{{ outgoingCheck.result_str }}</td>
              <td>
                <app-outgoing-item-status [sent]="outgoingCheck.sent" [sentInfo]="outgoingCheck.sent_at_str"></app-outgoing-item-status>
                &nbsp;
                <a href="#" (click)="$event.preventDefault(); outgoingCheck.sent ? restartOutgoingCheck(outgoingCheck) : finishOutgoingCheck(outgoingCheck)">
                  <i class="fas" [ngClass]="{ 'fa-redo': outgoingCheck.sent, 'fa-envelope': !outgoingCheck.sent, 'spin-reverse': outgoingCheck.sent, 'fa-spin': outgoingCheck.restarting || outgoingCheck.sending }"></i>
                  &nbsp;
                  {{ outgoingCheck.sent ? (outgoingCheck.restarting ? 'Restarting' : 'Restart') : outgoingCheck.sending ? 'Processing' : 'Finish' }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card mb-4 border-danger" *ngIf="!loading && outgoingJob && outgoingJob.failure_summary">
      <h4 class="card-header bg-danger text-white"><i class="fas fa-exclamation-triangle"></i>&nbsp; Failure Summary</h4>
      <div class="card-body">
        <div *ngIf="outgoingJob.failure_summary.succeeded && outgoingJob.failure_summary.succeeded.length > 0" class="mb-3">
          <h5 class="text-success"><i class="fas fa-check-circle"></i>&nbsp; What Worked</h5>
          <ul class="mb-0">
            <li *ngFor="let item of outgoingJob.failure_summary.succeeded">{{ item }}</li>
          </ul>
        </div>
        <div *ngIf="outgoingJob.failure_summary.failed && outgoingJob.failure_summary.failed.length > 0" class="mb-3">
          <h5 class="text-danger"><i class="fas fa-times-circle"></i>&nbsp; What Failed</h5>
          <ul class="mb-0">
            <li *ngFor="let item of outgoingJob.failure_summary.failed">{{ item }}</li>
          </ul>
        </div>
        <div *ngIf="outgoingJob.failure_summary.user_instructions && outgoingJob.failure_summary.user_instructions.length > 0">
          <h5><i class="fas fa-info-circle text-primary"></i>&nbsp; What To Do</h5>
          <ul class="mb-0">
            <li *ngFor="let instruction of outgoingJob.failure_summary.user_instructions" [innerHTML]="instruction"></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="card mb-4" *ngIf="!loading && outgoingJob && outgoingJob.instructions">
      <h4 class="card-header">Instructions</h4>
      <div class="card-body">
        <div class="card-text" [innerHTML]="outgoingJob.instructions"></div>
      </div>
    </div>
    <div class="card mb-4" *ngIf="!loading && outgoingJob && outgoingJob.message">
      <h4 class="card-header">Message</h4>
      <div class="card-body">
        <div class="card-text" [innerHTML]="outgoingJob.message"></div>
      </div>
    </div>
    <div class="card mb-4" *ngIf="!loading && outgoingJob && outgoingJob.priority">
      <div class="card-body bg-light">
        <h4 class="card-title text-danger">This is a PRIORITY job!</h4>
      </div>
    </div>
    <div class="card mb-4" *ngIf="!loading && outgoingJob && outgoingJob.outgoing_document_faxes && outgoingJob.outgoing_document_faxes.length > 0">
      <h4 class="card-header">Faxes</h4>
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th>Created</th>
              <th>Requested</th>
              <th>Completed</th>
              <th>Number</th>
              <th>Result</th>
              <th>Name</th>
              <th>Pages</th>
              <th>Message</th>
              <th>Bitrate</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let outgoingDocumentFax of outgoingJob.outgoing_document_faxes; let odd = odd">
              <tr>
                <td [ngClass]="{ 'table-secondary': !odd }">{{ outgoingDocumentFax.created_at_str }}</td>
                <td [ngClass]="{ 'table-secondary': !odd }">{{ outgoingDocumentFax.requested_at_str }}</td>
                <td [ngClass]="{ 'table-secondary': !odd }">{{ outgoingDocumentFax.completed_at_str }}</td>
                <td [ngClass]="{ 'table-secondary': !odd }">{{ outgoingDocumentFax.to_number }}</td>
                <td [ngClass]="{ 'table-secondary': !odd }">
                  <a target="_blank" [href]="'https://console.phaxio.com/viewFax?faxId=' + outgoingDocumentFax.fax_id"
                    [ngClass]="{ 'text-danger': outgoingDocumentFax.status == 'failure', 'text-success': outgoingDocumentFax.status == 'success' }"
                    [title]="outgoingDocumentFax.error_code || ''">
                    {{ outgoingDocumentFax.status == 'failure' ? 'Failure' : (outgoingDocumentFax.status == 'success' ? 'Success' : outgoingDocumentFax.status) }}
                  </a>
                  <div *ngIf="outgoingDocumentFax.status == 'failure' && outgoingDocumentFax.error_code" class="small text-danger">
                    {{ outgoingDocumentFax.error_code }}
                  </div>
                </td>
                <td [ngClass]="{ 'table-secondary': !odd }">{{ outgoingDocumentFax.document_name }}</td>
                <td [ngClass]="{ 'table-secondary': !odd }">{{ outgoingDocumentFax.num_pages }}</td>
                <td [ngClass]="{ 'table-secondary': !odd }">{{ outgoingDocumentFax.error_code ? outgoingDocumentFax.error_code : outgoingDocumentFax.message }}</td>
                <td [ngClass]="{ 'table-secondary': !odd }">{{ outgoingDocumentFax.bitrate }}</td>
              </tr>
              <tr class="bg-white text-center">
                <td [ngClass]="{ 'table-secondary': !odd }" colspan="9" class="border-0">
                  <img class="img-thumbnail" alt="..." [src]="outgoingDocumentFax.thumbnail_url" />
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card mb-4" *ngIf="!loading && outgoingJob && outgoingJob.fileshare_history_present">
      <h4 class="card-header">File Share Downloads</h4>
      <div class="card-body">
        <p class="card-text text-warning" *ngIf="!outgoingJob.fileshare_history_downloads || outgoingJob.fileshare_history_downloads.length < 1">Nothing has been downloaded for this job or this job was created before downloads were linked to the outgoing job.</p>
        <ng-container *ngFor="let download of outgoingJob.fileshare_history_downloads">
          <h5 class="card-title">{{ download.name }}</h5>
          <table class="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>IP Address</th>
                <th>Document</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of download.details">
                <td>{{ detail.datetime_str }}</td>
                <td>
                  <a [href]="'http://www.dnsstuff.com/tools#whois|type=ipv4&&value=' + detail.ip">{{ detail.ip }}</a>
                </td>
                <td>
                  <a [href]="detail.document_url" *ngIf="detail.document_url">
                    <i class="fas fa-file-pdf text-danger"></i>&nbsp;
                    {{ detail.document_name }}
                  </a>
                  <span class="text-muted font-italic" *ngIf="!detail.document_url">{{ detail.document_name }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
        </ng-container>
      </div>
    </div>
    <div *ngIf="loading" class="py-5 my-5 text-center"><i class="fas fa-spinner fa-fw fa-pulse fa-5x"></i></div>
    <div class="py-5"></div>
  </div>
</div>
<div class="py-5"></div>
